/**
 * V10 Phase C — 🚫 "이 관계 종료" Modal.
 *
 * Edge 자체 무력화 — KgEdge.temporal.invalidAt = now 세팅.
 * 노드/episodes 는 유지, 관계의 "끝났다" 표기. 삭제 아님.
 * 카운트다운 3초 · reason 필수.
 */
import { ConfirmCountdownModal } from "./ConfirmCountdownModal.tsx"

type Props = {
	readonly fromId: string
	readonly toId: string
	readonly relation: string
	readonly onClose: () => void
	readonly onConfirm: (reason: string) => Promise<void>
}

export function EdgeInvalidateModal(props: Props) {
	const edgeLabel = `${props.fromId.slice(-24)} ─${props.relation}→ ${props.toId.slice(-24)}`
	return (
		<ConfirmCountdownModal
			title="🚫 이 관계 종료"
			bodyCopy={`관계 "${edgeLabel}" 의 invalidAt = now 세팅. 노드/episodes 는 유지되고 "끝났다" 표기만 됩니다. 삭제 아닙니다.`}
			countdown={3}
			requireReason={true}
			confirmLabel="관계 종료"
			tone="danger"
			onClose={props.onClose}
			onConfirm={async (reason) => {
				if (!reason) throw new Error("사유는 필수입니다")
				await props.onConfirm(reason)
			}}
		/>
	)
}
